import React from "react";
import { Box, Button, Heading, Text } from "@chakra-ui/react";
import { MARKETING_LOCALES, MarketingLanguage } from "../../marketing-content/marketingLocales";
import recoveryTranslations from "../../marketing-content/recoveryTranslations.json";

/** This tiny app-catalog subset is eager so recovery never depends on a failed language chunk. */
export function MarketingLoadFailure({ language, reload = () => window.location.reload() }: {
  language: MarketingLanguage;
  reload?: () => void;
}) {
  const copy = recoveryTranslations[language];
  return (
    <Box as="main" data-marketing-page lang={MARKETING_LOCALES[language].htmlLang}
      dir={MARKETING_LOCALES[language].direction} minH="100vh" bg="#EDF2E6" color="#203D17"
      display="flex" alignItems="center" justifyContent="center" p={6}>
      <Box role="alert" maxW="32rem" textAlign="center">
        <Heading as="h1" fontSize={{ base: "2xl", md: "3xl" }} mb={4}>{copy.title}</Heading>
        <Text mb={6}>{copy.body}</Text>
        <Button onClick={reload} colorScheme="green" minH="44px">{copy.reload}</Button>
      </Box>
    </Box>
  );
}

